import { computed } from 'vue';
import { UserFunction } from '@carvia/ros-client-types';
import { useMe } from '@/queries/use-users';

/** True if the current user has the `Developer` function ("Entwickler"). */
export const useIsDeveloper = () => {
  const { data: me } = useMe();
  return computed(() => !!me.value?.functions?.includes(UserFunction.DEVELOPER));
};
